export { ContentGallery, type ContentGalleryProps } from './ContentGallery';
export { contentGallerySchema } from './schema';
